module.exports = __webpack_public_path__ + "img/灵活应用，智能管理ico.c8048d7a.png";